import { render, staticRenderFns } from "./MessageSystemNote.vue?vue&type=template&id=e4e232bc&scoped=true&"
import script from "./MessageSystemNote.vue?vue&type=script&lang=ts&"
export * from "./MessageSystemNote.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSystemNote.vue?vue&type=style&index=0&id=e4e232bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e232bc",
  null
  
)

export default component.exports